export default __webpack_public_path__ + "static/media/no.cbfb869c.jpg";